const KEY = "cart_promotions";
export default class PromotionStorageManager {
    constructor(params) {
        this.promotionScheme = params.promotionScheme;
        this.coupon = params.coupon;
    }
    store() {
        console.log("Coupon code", this.promotionScheme.couponCodes.toString());
        const data = {
            coupon: this.promotionScheme.couponCodes[0],
            promotions: this.promotionScheme.promotionInstances.map((promotionalInstance) => {
                if (promotionalInstance.kind === "Product") {
                    return {
                        kind: "SerializedProductPromotionInstance",
                        id: promotionalInstance.id,
                        active: promotionalInstance.active,
                        promotionTypeId: promotionalInstance.promotionType.id,
                    };
                }
                else {
                    return {
                        kind: "SerializedWholeOrderPromotionInstance",
                        id: promotionalInstance.id,
                        active: promotionalInstance.active,
                        promotionTypeId: promotionalInstance.promotionType.id,
                    };
                }
            }).raw,
        };
        const dataString = JSON.stringify(data);
        console.log("Store Promotions", dataString);
        localStorage.setItem(KEY, dataString);
    }
    restore() {
        const dataString = localStorage.getItem(KEY);
        if (dataString === null) {
            return;
        }
        const data = JSON.parse(dataString);
        if (this.coupon.type === "Enabled" &&
            data.coupon !== undefined &&
            data.coupon !== null) {
            this.coupon
                .submitCoupon(data.coupon)
                .catch(() => console.log("Restore Coupon issue"));
        }
        const result = data.promotions.map((promotion) => {
            if (promotion.kind === "SerializedProductPromotionInstance") {
                console.log("SerializedProductPromotionInstance", promotion);
            }
            else {
                console.log("SerializedWholeOrderPromotionInstance", promotion, this.promotionScheme.promotionInstances);
                this.promotionScheme.promotionInstances
                    //.filtered(promotionInstance => promotionInstance.id === promotion.id)
                    //.forEach(x => console.log("PromIns", x))
                    //.forEach(promotionInstance => promotionInstance.setActive(promotion.active))
                    .forEach((promotionInstance) => promotionInstance.setActive(false));
            }
        });
        console.log("restorePromotions", result);
    }
    static erase() {
        localStorage.removeItem(KEY);
    }
}
